import options from './autocomplete.component';

export default {
    selector: 'dtEntitiesAutocomplete',
    options
};



// WEBPACK FOOTER //
// ./app/common/entities-autocomplete/index.js